import { render } from "./Assortiment.vue?vue&type=template&id=72eb6982"
import script from "./Assortiment.vue?vue&type=script&lang=js"
export * from "./Assortiment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__